import { Skeleton } from "@/components/ui/skeleton";
const CardLoader = () => <div className="w-full max-w-[180px]" data-sentry-component="CardLoader" data-sentry-source-file="card-loader.tsx">
    <Skeleton className="w-full aspect-square rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="card-loader.tsx" />
    <Skeleton className="mx-auto mt-[20px] h-[10px] w-[70%]" data-sentry-element="Skeleton" data-sentry-source-file="card-loader.tsx" />
  </div>;
export default CardLoader;